export function loadFacebookSdk(appId, onSdkReady, onMessageEvent) {
  if (window.FB) {
    onSdkReady?.();
    return;
  }

  window.fbAsyncInit = function () {
    FB.init({
      appId,
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v22.0',
    });

    onSdkReady?.();
  };

  if (!document.getElementById('facebook-jssdk')) {
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
  }

  window.addEventListener('message', (event) => {
    if (!event.origin.includes('facebook.com')) return;

    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        onMessageEvent?.(data);
      }
    } catch {
      onMessageEvent?.(event.data);
    }
  });
}